import React, { memo, forwardRef, ForwardedRef } from "react";
// libs
import RatingLib, { RatingComponentProps } from "react-rating";
import { FlexColumn } from "src/components/ui/common";
// components
import Rating from "src/components/ui/Rating";
import { colors } from "src/theme";
import { Caption, Headline } from "src/theme/typography";

interface IRateStarsContainer extends RatingComponentProps {
  title: string;
  error?: string;
}

const RateStarsContainer = (
  { title, error, ...rest }: IRateStarsContainer,
  ref: ForwardedRef<RatingLib>,
) => {
  return (
    <>
      <FlexColumn gap="8px">
        <Headline>{title}</Headline>
        <Rating width={40} height={38} {...rest} ref={ref} />
        {error && <Caption textColor={colors.redDark}>{error}</Caption>}
      </FlexColumn>
    </>
  );
};

export default memo(forwardRef(RateStarsContainer));
